// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ed8f56a","453":"337c40be","455":"483ef0cb","977":"9c800fdb"}[chunkId] + ".chunk.js";
};